import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './systemConfig.module.css';
import MyTooltip from '../components/Utilities/MyTooltip';
import {RedButton, GreenButton, BlueButton} from '../components/MyButton';

import {MyInput} from '../components/Utilities/MyInput';

export default function AudioConfig() {
	const navigate = useNavigate();
	
	const [azureVoiceName, setAzureVoiceName] = useState([]);
	
	const [punct_1, setPunct_1] = useState("");
	const [punct_2, setPunct_2] = useState("");
	const [punct_3, setPunct_3] = useState("");
	const [punct_4, setPunct_4] = useState("");
	const [punct_5, setPunct_5] = useState("");
	
	const [stu_a, setStu_a] = useState("");
	const [stu_b, setStu_b] = useState("");
	const [stu_c, setStu_c] = useState("");
	const [stu_d, setStu_d] = useState("");
	
	const fetchData = () => {
		getData('audioApi/listAzureVoiceName', navigate)
		.then(res => {
			setAzureVoiceName(res.data);
		});
		
		getData('audioApi/getAzureAudioConfig', navigate)
		.then(res => {
				let d = res.data;
				
				setPunct_1(d.punct_1);
				setPunct_2(d.punct_2);
				setPunct_3(d.punct_3);
				setPunct_4(d.punct_4);
				setPunct_5(d.punct_5);
				
				setStu_a(d.stu_a);
				setStu_b(d.stu_b);
				setStu_c(d.stu_c);
				setStu_d(d.stu_d);
			}
		);
		
		
	}
	
	const setAzureAudioConfig = (itemId, indexD) => {
		/*
		let obj = {
			'itemId' : itemId,
			'isPublished' : tmpItems[indexD].isPublished,
		}
		postData("audioApi/setAzureAudioConfig", obj, navigate); */
	}
	
	const syncPathsToAliyun = () => {
		
		for (let p of mediaPaths) {
		
			let obj = {
				'path' : p
			}
			postData("utility/syncPathToAliyun", obj, navigate);
		}
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	const [mediaPaths, setMediaPaths] = useState("");
	
	return (<div>
	
	
	
		<div className="generalTitleHolder">
			<div>System Config</div>			
			<MyTooltip msg={"&lt;page&gt;" +
										"systemConfig.js<br/><br/>" +
										"&lt;components&gt;<br/>" +
										" X <br/>"} /> 
			
		</div>
		
		<div className="generalPartHolder">
			<div>Sync Paths to aliyun</div>
			<div>			
				<textarea className="generalTextarea" style={{width:"100%"}}
					value={mediaPaths} rows={10} 
					placeholder="Input paths of media files&#10;For example:&#10;https://ehla-media-bucket.s3.amazonaws.com/general/28015/28015-1738635935089.png&#10;general/28015/28015-1738635935089.png"
					wrap='off' onChange={(e) => {setMediaPaths(e.target.value)}} />
			</div>
			<div>
				<GreenButton isEnabled={true} clickedAction={syncPathsToAliyun} bText={"Sync"} />	
			</div>

		</div>
		<div className="generalPartHolder">
			<div>Azure Audio Config</div>
		
			<div style={{textAlign:"left", fontWeight:"bold", margin:"0 5px"}}>Delay time</div>
			
			<SpeedSetting label={","} value={punct_1} setValue={setPunct_1} />
			<SpeedSetting label={";"} value={punct_2} setValue={setPunct_2} />
			<SpeedSetting label={"."} value={punct_3} setValue={setPunct_3} />
			<SpeedSetting label={"!"} value={punct_4} setValue={setPunct_4} />
			<SpeedSetting label={"?"} value={punct_5} setValue={setPunct_5} />
			
			<div style={{textAlign:"left", fontWeight:"bold", margin:"0 5px"}}>Student voice</div>
			
			<MyInput inputLabel={"A"} dataInput={stu_a} changeAction={setStu_a} />
			<MyInput inputLabel={"B"} dataInput={stu_b} changeAction={setStu_b} />
			<MyInput inputLabel={"C"} dataInput={stu_c} changeAction={setStu_c} />
			<MyInput inputLabel={"D"} dataInput={stu_d} changeAction={setStu_d} />
		</div>
	</div>)
}



const SpeedSetting = ({label, value, setValue}) => {
	return (<div className={s.inputAudio}>
		<div>{label}</div>
		<select value={value} onChange={(e)=>{setValue(e.target.value);}}>
			<SpeedOption />
		</select>
	</div>)
}


const SpeedOption = () => {
	return (<>
		<option value="X-weak">X-weak</option>
		<option value="Weak">Weak</option>
		<option value="Medium">Medium</option>
		<option value="Strong">Strong</option>
		<option value="X-strong">X-strong</option></>);
}

const PunctuationSelector = (itemId, indexD) => {

}

